import { SitesInfo200Resources } from '@newfold/huapi-js/src/index.schemas';

import { SiteInfoType } from '~/types/site';

const siteResources: SitesInfo200Resources = {
  storage: {
    available: 23,
    total: 25,
    unit: 'GB',
    used: 2,
  },
  workers: 2,
};

// TODO: bring these up to date with the SiteInfo200 / HostingSitesV2200ItemsItem models (which should be identical)

export const siteWelcome = {
  id: 50,
  account_id: '8000',
  name: 'Welcome',
  url: 'http://hmn.qgc.temp-bh.newfold-dev.site',
  domain: 'hmn.qgc.temp-bh.site',
  docroot: 'public_html',
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pagespeed: {
    lastrun: '2025-03-11 06:09:34',
    performance: '0.91',
    strategy: 'DESKTOP',
  },
  url_is_provisional: true,
  resources: {
    ...siteResources,
  },
};

export const siteActive: SiteInfoType = {
  id: 1,
  account_id: '1000',
  name: 'Active WP Site',
  handler_404: 'index.php',
  url: 'https://dougclarkfinewoodworking.com',
  base_domain: 'dougclarkfinewoodworking.com',
  domain: 'dougclarkfinewoodworking.com',
  docroot: 'public_html',
  docpath: 'public_html',
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pagespeed: {
    lastrun: '2025-03-11 06:09:34',
    performance: '0.91',
    strategy: 'DESKTOP',
  },
  pending_url: 'https://www.dougclarkfinewoodworking.com',
  pending_url_data: {
    domain_id: 1,
    domain: 'www.dougclarkfinewoodworking.com',
    base_domain: 'dougclarkfinewoodworking.com',
  },
  url_is_provisional: true,
  resources: {
    ...siteResources,
  },
};

export const siteActiveOther: SiteInfoType = {
  id: 11,
  account_id: '1000',
  name: 'Active Site',
  url: 'https://zdf.tesg.com',
  domain: 'zdf.tesg.com',
  docroot: 'public_html/site-uuid-or-something-1',
  status: 'active',
  type: 'generic',
  detected_type: 'generic',
  pending_url: null,
  url_is_provisional: true,
  resources: {
    ...siteResources,
  },
};

export const siteActivePendingUrl: SiteInfoType = {
  id: 2,
  account_id: '1000',
  name: 'Active PendingURL Site',
  url: 'http://zdf.tesg2.com',
  base_domain: 'tesg2.com',
  domain: 'zdf.tesg2.com',
  docroot: 'public_html/site-uuid-or-something-1',
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: 'https://pending.url.com',
  pending_url_data: {
    domain_id: 3,
    domain: 'pending.url.com',
    base_domain: 'url.com',
  },
  url_is_provisional: false,
  resources: {
    ...siteResources,
  },
};

export const siteActivePendingUrlOther: SiteInfoType = {
  id: 12,
  account_id: '1000',
  name: 'Active PendingURL Site Other',
  url: 'http://zdf.tesg2.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-1',
  status: 'active',
  type: 'generic',
  detected_type: 'generic',
  pending_url: 'https://pending.url.com',
  url_is_provisional: false,
  resources: {
    ...siteResources,
  },
};

export const sitePendingStopDecom: SiteInfoType = {
  id: 3,
  account_id: '1000',
  name: 'Pending Stop Decom Site',
  url: 'http://zdf.tesg3.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-3',
  status: 'pending_stop_decom',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  url_is_provisional: null,
  resources: {
    ...siteResources,
  },
};

export const sitePendingRestore: SiteInfoType = {
  id: 4,
  account_id: '1000',
  name: 'Pending Restore Site',
  url: 'http://zdf.tesg4.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-4',
  status: 'pending_restore',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteDeleting: SiteInfoType = {
  id: 5,
  account_id: '1000',
  name: 'Deleting Site',
  url: 'http://zdf.tesg5.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-5',
  status: 'delete',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteFailedDelete: SiteInfoType = {
  id: 6,
  account_id: '1000',
  name: 'Failed Delete Site',
  url: 'https://zdf.tesg6.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-6',
  status: 'failed_delete',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
};

export const siteDeleted: SiteInfoType = {
  id: 7,
  account_id: '1000',
  name: 'Deleted Site',
  url: 'http://zdf.tesg7.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-7',
  status: 'deleted',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteCreating: SiteInfoType = {
  id: 8,
  account_id: '1000',
  name: 'Creating Site',
  url: 'http://zdf.tesg8.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html',
  status: 'pending_create',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  version: 'v 6.4.2',
  php_version: 'v 6.0.0',
  resources: {
    ...siteResources,
  },
};

export const siteFailedCreate: SiteInfoType = {
  id: 9,
  account_id: '1000',
  name: 'Failed Create Site',
  url: 'http://zdf.tesg9.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-9',
  status: 'failed_create',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteDecom: SiteInfoType = {
  id: 13,
  account_id: '1000',
  name: 'Decom Site',
  url: 'http://zdf.tesg13.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-13',
  status: 'decom',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteDisabled: SiteInfoType = {
  id: 14,
  account_id: '1000',
  name: 'Disabled Site',
  url: 'http://zdf.tesg14.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-14',
  status: 'disabled',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteTOS: SiteInfoType = {
  id: 15,
  account_id: '1000',
  name: 'TOS Suspended Site',
  url: 'http://zdf.tesg15.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-15',
  status: 'tos',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteAUP: SiteInfoType = {
  id: 16,
  account_id: '1000',
  name: 'AUP Suspended Site',
  url: 'http://zdf.tesg16.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-16',
  status: 'aup',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteReassignDomain: SiteInfoType = {
  id: 17,
  account_id: '1000',
  name: 'ReassignDomain Site',
  url: 'https://reassignDomain.com',
  domain: 'reassignDomain.com',
  docroot: 'public_html',
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteWithoutUrl: SiteInfoType = {
  id: 99,
  account_id: '1000',
  name: 'Site Without URL',
  url: null,
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-without-url',
  status: 'failed_create',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

// id 400 to trigger api errors
export const siteWithErrors: SiteInfoType = {
  id: 400,
  account_id: '1000',
  name: 'Site With Errors',
  url: null,
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-with-errors',
  status: 'failed_create',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteMigration: SiteInfoType = {
  id: 20,
  account_id: '1000',
  name: 'MigrationSite',
  url: 'http://zdf.tesg7.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-7',
  status: 'pending_create',
  type: 'wordpress',
  detected_type: 'wordpress',
  migration_id: '9fab2a4e777e8c222c7e44c8',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteMigrationFailed: SiteInfoType = {
  id: 21,
  account_id: '1000',
  name: 'Migration Failed',
  url: 'http://test.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-7',
  status: 'failed_create',
  type: 'wordpress',
  detected_type: 'wordpress',
  migration_id: '9fab2a4e777e8c222c7e44c8',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteBuilderWeebly: SiteInfoType = {
  id: 30,
  account_id: '1000',
  name: 'Weebly Builder Site',
  url: 'http://builder.weebly.com',
  domain: 'builder.weebly.com',
  docroot: 'public_html/site-uuid-or-something-30',
  status: 'active',
  type: 'builder',
  detected_type: 'builder',
  subtype: 'weebly',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteBuilderWebzai: SiteInfoType = {
  id: 31,
  account_id: '1000',
  name: 'Webzai Builder Site',
  url: 'http://builder.webzai.com',
  domain: 'builder.webzai.com',
  docroot: 'public_html/site-uuid-or-something-31',
  status: 'active',
  type: 'builder',
  detected_type: 'builder',
  subtype: 'webzai',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteBuilderMulti: SiteInfoType = {
  id: 32,
  account_id: '1000',
  name: 'Multi Builder Site',
  url: 'http://builder.multi.com',
  domain: 'builder.multi.com',
  // domain: null,
  docroot: 'public_html/site-uuid-or-something-32',
  status: 'active',
  type: 'builder',
  detected_type: 'builder',
  subtype: 'multi',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteGenericWithoutNameAndUrl: SiteInfoType = {
  id: 999,
  account_id: '1000',
  name: null,
  url: null,
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/other-site-without-url',
  status: 'active',
  type: 'generic',
  detected_type: 'generic',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteFailedReset: SiteInfoType = {
  id: 362,
  account_id: '1000',
  name: 'Failed Resetting Site',
  url: 'http://zdf.tesg362.com',
  docroot: 'public_html/site-uuid-or-something-362',
  status: 'failed_reset',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteResetting: SiteInfoType = {
  id: 363,
  account_id: '1000',
  name: 'Resetting Site',
  url: 'http://zdf.tesg363.com',
  docroot: 'public_html/site-uuid-or-something-363',
  status: 'pending_reset',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteMismatched: SiteInfoType = {
  id: 40,
  account_id: '1000',
  name: 'Mismatched Site',
  url: 'http://zdf.tesg40.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-40',
  status: 'active',
  type: 'wordpress',
  detected_type: 'generic',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteNullDocRoot: SiteInfoType = {
  id: 41,
  account_id: '1000',
  name: 'Null DocRoot Site',
  url: 'http://zdf.tesg41.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: null,
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteExpiredHosting: SiteInfoType = {
  id: 42,
  account_id: '5000',
  name: 'Expired Hosting Site',
  url: 'http://zdf.tesg42.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-42',
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  resources: {
    ...siteResources,
  },
};

export const siteCloudHosting: SiteInfoType = {
  id: 100,
  account_id: '6000',
  name: 'Cloud Hosting Site',
  url: 'example.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-100',
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  version: 'v 6.4.2',
  php_version: 'v 6.0.0',
  resources: {
    ...siteResources,
  },
};

export const siteCloudSuspendedHosting: SiteInfoType = {
  id: 101,
  account_id: '7000',
  name: 'Suspended Cloud Hosting Site',
  url: 'example.com',
  domain: 'rock219.eigdev.temp.domains',
  docroot: 'public_html/site-uuid-or-something-101',
  status: 'active',
  type: 'wordpress',
  detected_type: 'wordpress',
  pending_url: null,
  version: 'v 6.4.2',
  php_version: 'v 6.0.0',
  resources: {
    ...siteResources,
  },
};

export const siteCloudStagingParent: SiteInfoType = {
  id: 102,
  account_id: '6000',
  name: 'Staging Parent Site',
  url: 'http://example.com',
  domain: 'example.com',
  docroot: 'public_html/site-uuid-or-something-102',
  status: 'active',
  type: 'wordpress',
  subtype: 'atomic',
  detected_type: 'wordpress',
  pending_url: null,
  version: 'v 6.4.2',
  php_version: 'v 6.0.0',
  resources: {
    ...siteResources,
  },
  staging: {
    parent_site_id: null,
    promoted_from: null,
    promoting_from: null,
    promotion_status: null,
    sites: [100],
  },
};

export const siteCloudStaging: SiteInfoType = {
  ...siteCloudStagingParent,
  id: 103,
  name: 'Staging Site',
  staging: {
    parent_site_id: 100,
    promoted_from: null,
    promoting_from: null,
    promotion_status: 'not_promoting',
    sites: [],
  },
};

export const sitesEmpty = [];
export const sitesOneActive = [siteActive];
export const sitesOneActivePendingUrl = [siteActivePendingUrl];
export const sitesOnePendingStopDecom = [sitePendingStopDecom];
export const sitesOnePendingRestore = [sitePendingRestore];
export const sitesOneCreating = [siteCreating];
export const sitesOneFailedCreate = [siteFailedCreate];
export const sitesOneDecom = [siteDecom];
export const sitesOneDisabled = [siteDisabled];
export const sitesOneTOS = [siteTOS];
export const sitesOneAUP = [siteAUP];
export const sitesOneReassignDomain = [siteReassignDomain];
export const sitesOneDeleting = [siteDeleting];
export const sitesOneFailedDelete = [siteFailedDelete];
export const sitesOneDeleted = [siteDeleted];
export const sitesOneMismatched = [siteMismatched];
export const sitesOneNullDocRoot = [siteNullDocRoot];
export const sitesOneExpiredHosting = [siteExpiredHosting];
export const sitesOneCloudHosting = [siteCloudHosting];
export const sitesOneStagingParent = [siteCloudStagingParent];
export const sitesOneStaging = [siteCloudStaging];
export const siteOneWelcome = [siteWelcome];
export const sitesList: SiteInfoType[] = [
  siteActive,
  siteActiveOther,
  siteActivePendingUrl,
  siteActivePendingUrlOther,
  sitePendingStopDecom,
  sitePendingRestore,
  siteFailedCreate,
  siteDecom,
  siteDisabled,
  siteAUP,
  siteTOS,
  siteReassignDomain,
  siteDeleting,
  siteFailedDelete,
  siteWithoutUrl,
  siteWithErrors,
  siteMigration,
  siteMigrationFailed,
  siteBuilderWeebly,
  siteBuilderWebzai,
  siteBuilderMulti,
  siteGenericWithoutNameAndUrl,
  siteFailedReset,
  siteResetting,
  siteMismatched,
  siteNullDocRoot,
  siteExpiredHosting,
  siteCloudHosting,
  siteCloudSuspendedHosting,
  siteCloudStagingParent,
  siteCloudStaging,
  siteWelcome,
];
export const sitesListWithPendingCreate = [...sitesList, siteCreating];
